import Vue from "vue";
import Vuex from "vuex";
import webproduct from "./modules/webproduct";
import config from "./modules/config";
import changeOptions from "./modules/changeOptions";
import custom from "./modules/custom";
import quantityField from "./modules/quantityField";
import costCenter from "./modules/costCenter";
import packingOptions from "./modules/packingOptions";
import personalize from "./modules/personalize";
import preview2D from "./modules/preview2D";
import preview3D from "./modules/preview3D";
import urls from "./modules/urls";
import preflightPitstop from "./modules/preflightPitstop";
import imageEditor from "./modules/imageEditor";
import preflightData from "./modules/preflightData";
import customer from "./modules/customer";
import editorFiles from "./modules/editorFiles";
import myAccount from "./modules/myAccount";
import summaryPageOption from "./modules/summaryPageOption";
import tooltips from "./modules/tooltips";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    webproduct,
    config,
    changeOptions,
    custom,
    quantityField,
    costCenter,
    packingOptions,
    personalize,
    preview2D,
    preview3D,
    urls,
    preflightPitstop,
    imageEditor,
    preflightData,
    customer,
    editorFiles,
    myAccount,
    summaryPageOption,
    tooltips
  }
});
